/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Payment_Upcoming_ReceivableInputs */

const en_case_payment_upcoming_receivable = /** @type {(inputs: Case_Payment_Upcoming_ReceivableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upcoming receivable`)
};

const pt_br2_case_payment_upcoming_receivable = /** @type {(inputs: Case_Payment_Upcoming_ReceivableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valor a receber — a vencer`)
};

/**
* | output |
* | --- |
* | "Upcoming receivable" |
*
* @param {Case_Payment_Upcoming_ReceivableInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_upcoming_receivable = /** @type {((inputs?: Case_Payment_Upcoming_ReceivableInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Upcoming_ReceivableInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_upcoming_receivable(inputs)
	return pt_br2_case_payment_upcoming_receivable(inputs)
});